import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizClosedTranslations: Quiz409Translations = {
  title: '',
  subMessage:
    "Thank you for your interest, but we've already closed applications. See you next year!",
  buttons: {
    back: 'Start',
  },
};
